/**
 * Tenant brand selection (TO-380, ADR-0045): a tenant stores one Brand Studio brand id; the brand
 * itself lives in the runtime brand catalogue (`@today/brand-config/catalog`).
 */

/**
 * The status of a catalogue brand as it crosses the wire: the production-eligible subset of
 * `@today/brand-config`'s `BrandStatus`, with the same values. Only `PUBLISHED` is selectable.
 */
export enum CatalogBrandStatus {
	PUBLISHED = 'published',
	DEPRECATED = 'deprecated',
}

/** One item of `GET /admin/brands`. */
export interface CatalogBrandItemDTO {
	id: string
	name: string
	status: CatalogBrandStatus
	/** True exactly when `status` is `published`. */
	selectable: boolean
}

/** The brand a tenant view resolves to: catalogue name, status and `semantic.colors.*` palette. */
export interface TenantBrandDTO {
	id: string
	name: string
	status: CatalogBrandStatus
	/** `semantic.colors.<name>` token → its resolved value. */
	palette: Record<string, string>
}

/**
 * The tenant brand view (REQ-006): the stored brand id (or null) and, when that id is in the
 * catalogue, the resolved brand — `null` when no id is stored or the id left the catalogue.
 */
export interface TenantBrandViewDTO {
	tenantId: string
	brandId: string | null
	brand: TenantBrandDTO | null
}
